import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  imports: [MainLayoutComponent, RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly loggingService = inject(LoggingService);

  title = 'web-toyo';

  constructor() {
    this.loggingService.warn('NG_APP_ENV', import.meta.env.NG_APP_ENV);
  }
}
